import React from 'react'

import DashboardWrapper from '../DashboardWrapper'

import OverviewCharts from './overview'
import MonthlyCharts from './monthly'
import QuarterlyCharts from './quarterly'

import PDFExport from './PDFExport'

const ChartsExport = () => {
    return (
        <PDFExport>
            <DashboardWrapper>
                <div className="report-container">
                    <OverviewCharts />
                </div>
            </DashboardWrapper>
            <DashboardWrapper>
                <div className="report-container">
                    <MonthlyCharts />
                </div>
            </DashboardWrapper>
            <DashboardWrapper>
                <div className="report-container">
                    <QuarterlyCharts />
                </div>
            </DashboardWrapper>
        </PDFExport>
    )
}

export default ChartsExport